export enum PharmacyDetailsStepsEnum {
  NpiNumber = 0,
  Details = 1,
}
